import APIService from '@/services/APIService.js';

export default {
  getModelos() {
    return APIService.apiCall().get('/modelosCadernosServicos/getModelos');
  },
  criar(data) {
    return APIService.apiCall().post('/modelosCadernosServicos/criar', JSON.stringify(data));
  },
  download(id) {
    return APIService.apiCall().get(`/modelosCadernosServicos/baixar/${id}`, {
      responseType: 'blob'
    });
  },
  executar(id) {
    return APIService.apiCall().get(`/modelosCadernosServicos/executar/${id}`);
  }
};
